import React from 'react';
import { Footer as CmsFooter } from '@goodfynd/layout';
import { styled } from '@goodfynd/theme';

import CartProvider from '../../context/cart-context/CartContext';

import { STANDARD_FOOTER } from './footer-data';
import Footer from './Footer';
import Header from './Header';

const StyledLayout = styled('div', {
  fontSize: 16,
  display: 'block',
  paddingTop: 64,
  flexGrow: 1,
});

const StyledContainer = styled('div', {
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  minWidth: '100vw',
});

type LayoutProps = {
  children: React.ReactNode;
  headerFixed?: boolean;
  headerShadow?: boolean;
  showNav?: boolean;
};

export default function Layout({
  children,
  headerFixed = true,
  headerShadow = true,
  showNav = true,
}: LayoutProps): JSX.Element {
  return (
    <CartProvider>
      <Header fixed={headerFixed} shadow={headerShadow} showNav={showNav} />
      <StyledContainer>
        <StyledLayout>{children}</StyledLayout>

        {showNav ? (
          <CmsFooter {...STANDARD_FOOTER} />
        ) : (
          <Footer showNav={showNav} />
        )}
      </StyledContainer>
    </CartProvider>
  );
}
